import styled from "styled-components";

export const LoginWrapper = styled.section`
  height: 100svh;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
`;

export const Header = styled.header`
  display: grid;
  height: 30%;
  place-items: center;
`;

export const ButtonDiv = styled.div`
  display: flex;
  flex-direction: column;
  height: 84%;
  align-items: center;
  justify-content: center;
  gap: 2rem;
`;
export const Divv = styled.div`
  width: 96%;
  height: 0;
  border-bottom: 0.1px solid ${(props) => props.theme.whiteColor}; /* change color and thickness as desired */
  text-align: center;
  position: relative;
  margin: 1rem 0;
`;

export const Divider = styled.span`
  display: inline-block;
  color: white;
  position: relative;
  top: -10px; /* adjust this value to vertically center the text */
  background-color: ${(props) =>
    props.theme.primaryColor}; /* change background color as desired */
  padding: 0 10px;
  font-size: 18px;
`;

export const Separator = styled.h4`
  &:before,
  &:after {
    content: "";
    flex: 1 1;
    border-bottom: 2px solid ${(props) => props.theme.whiteColor};
    margin: auto;
    color: ${(props) => props.theme.whiteColor};
  }
`;

export const Body = styled.section`
  height: 70%;
  background: linear-gradient(180deg, #440e69 -4.61%, #221b3c 40.69%);
  border-radius: 50px 50px 0px 0px;
  padding: 4rem;
  position: relative;
`;

export const Footer = styled.footer`
  width: calc(100% - 4rem);
  bottom: 4rem;
  left: 2rem;
  position: absolute;
  z-index: 999;
`;

export const InputFieldWrapper = styled.div`
  position: absolute;
  width: calc(100% - 8rem);
  top: 50%;
  transform: translateY(-50%);
  & > span {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    color: white;
    font-size: 18px;
    display: flex;
    justify-content: center;
  }
  & > span > div {
    width: 1px;
    background-color: white;
    height: 18px;
    margin-left: 0.6rem;
  }
  & > img {
    position: absolute;
    right: 0;
    cursor: pointer;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const Error = styled.p`
  color: red;
  font-size: 1.4rem;
  margin-top: 0.8rem;
  z-index: 9;
  position: absolute;
`;
